import * as Yup from 'yup'
import { 
    reverseShape
} from 'Components/shared/helpers/reverse-shape'
import { 
    decimal, 
    validString, 
} from 'Components/shared/helpers/validations'

const dimension = Yup.object().shape(reverseShape({
    length: decimal.required(),
    width: decimal.required(),
    height: decimal.required(),
})) 

export const TrolleySchema = Yup.object().shape(reverseShape({
    _id: validString.optional(),
    dimension: dimension.required(),
    maxDimension: decimal.required(),
    capacity: decimal.required(),
    maxLoad: decimal.required(),
    trolleyType: validString.required(),
    noOfUnits: decimal.optional(),
    name: validString.optional()
})) 
